import { MessagePayload } from 'firebase/messaging';

type FirebaseNotificationTypeType =
  | 'review'
  | 'task'
  | 'order'
  | 'possible_delay'
  | 'serious_delay'
  | 'delay';

export type FirebaseNotificationType = {
  id: string;
  title: string;
  body: string;
  read?: boolean;
  rate?: number;
  type: FirebaseNotificationTypeType;
  createdAt?: number;
};

export interface HandlePrepareDataArgs {
  payload: MessagePayload;
  handleAddIndexedDb: (idb: FirebaseNotificationType, src: unknown) => Promise<void>;
}

export const handlePrepareData = async (props: HandlePrepareDataArgs) => {
  const { data, notification } = props.payload;
  const title = notification?.title || 'Informer Account';

  let resultObject: Partial<FirebaseNotificationType> = {};

  if (data) {
    const type = data.type;
    const item = data.item ? JSON.parse(data.item) : undefined;

    if (type === 'review') {
      const id = `review-${item.task_type}-${item.id}`;

      resultObject = {
        id,
        rate: item.rating,
        body: item.content,
        read: false,
        type: 'review',
        title,
      };
    }

    if (['task', 'order'].includes(type)) {
      const id = `${item.type}-${item.id}`;
      const type = item.type === 'ORDER' ? 'order' : 'task';

      resultObject = {
        id,
        body: item.client_comment || item.comment,
        read: false,
        title,
        type,
      };
    }

    if (['possible_delay', 'serious_delay', 'delay'].includes(type)) {
      const id = `delay-${item.id}`;

      resultObject = {
        id,
        body: notification?.body,
        read: false,
        title,
        type: type as FirebaseNotificationTypeType,
      };
    }
    resultObject.createdAt = Date.now();
    await props.handleAddIndexedDb(resultObject as FirebaseNotificationType, item);
  }
  return resultObject;
};

export const notifMap: Record<FirebaseNotificationType['type'], string> = {
  review: 'Отзыв',
  task: 'Задача',
  order: 'Заказ',
  delay: 'Опоздание',
  possible_delay: 'Возможное опоздание',
  serious_delay: 'Серьезное опоздание',
};

export const decodeHTML = (html: string) => {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
};
